import IFACE, { EL } from './IFACE.js';
import Collapse from '../event/Collapse.js';
import Expand from '../event/Expand.js';
import Toggle from '../event/Toggle.js';
/** A series of Collapse Related Events and Methods
    By default, a collapsible element is collapsed
*/
export default class Collapsible extends IFACE {
    constructor(node) {
        super(node, 'collapsible');
    }
    addListeners(node) {
        node.on('collapse', () => node.collapse());
        node.on('expand', () => node.expand());
        node.on('toggle', () => node.toggle());
    }
    setMethods(node) {
        /** Collapses the node
            @returns {Promise<ThisType>} Promise Chain
        */
        this.methods.collapse = () => node.chain(() => {
            node.addClass('collapsed');
            node.removeClass('expanded');
            let content = node.nextElementSibling;
            if (typeof content !== 'undefined') {
                content.style.maxHeight = null;
            }
        });
        /** Expands the node
            @returns {Promise<ThisType>} Promise Chain
        */
        this.methods.expand = () => node.chain(() => {
            node.addClass('expanded');
            node.removeClass('collapsed');
            let content = node.nextElementSibling;
            if (typeof content !== 'undefined') {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
        /** Toggles the node
            @returns {Promise<ThisType>} Promise Chain
        */
        this.methods.toggle = () => this.toggle('in', new Expand(node), new Collapse(node));
    }
}
export { Collapse, EL, Expand, IFACE, Toggle };
